import * as React from 'react';
import Loader from '../components/Loader';
import NotFound from './NotFound';
import EditFeed from './EditFeed';
import { useRequest, getHeaders } from '../api/client';
import { ProfileContext, ProfileManager } from '../profile';
import { RouteComponentProps } from 'react-router';

const feed = (id: string, context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    url: `/feeds/${id}`,
    method: 'GET',
    headers: getHeaders(context),
  }));

  return state;
};

const getStateEntity = (props: RouteComponentProps<any>) => {
  return props.location.state ? props.location.state.feed : null;
};

const getEntityID = (props: RouteComponentProps<any>) => {
  return props.match.params.feedId;
};

export function withState(Component: any) {
  return (props: RouteComponentProps<any>) => {
    const context = React.useContext(ProfileContext);
    const preloadedEntity = getStateEntity(props);

    if (preloadedEntity) {
      return <Component feed={preloadedEntity} />;
    }

    const state = feed(getEntityID(props), context);

    if (state.loading || !state.data) {
      return <Loader />;
    }

    if (state.error) {
      return <NotFound />;
    }

    return <Component feed={state.data} />;
  };
}

export default withState(EditFeed);
